import { VidchatRoom } from './components/VidchatRoom.js';

export function App() {
    return <VidchatRoom />;
}
